{
  "screen": {
    "overline": "ГЛОБАЛЬНЫЙ ПРАКТИКУМ",
    "title": "Календарь",
    "subtitle": "Ваш персональный календарь событий. Live-сессии, ретриты, воркшопы и церемонии — всё собрано в одном месте, под ваш ритм и интересы.",
    "liveStreams": "Live-сессии",
    "programEvent": {
      "note": "Входит в купленную программу",
      "cta": "В программе"
    },
    "eventsTab": "События",
    "loading": "Загрузка Live-сессий...",
    "noSessions": "Нет предстоящих сессий",
    "noSessionsHint": "Загляните позже — новые Live-сессии от мастеров со всего мира.",
    "browseEvents": "Смотреть события",
    "streamingNow": "LIVE",
    "upcomingSessions": "Предстоящие сессии",
    "allSessions": "Все сессии",
    "subscribed": "Подписки",
    "subscribedCount": "Подписки ({{count}})",
    "allTraditions": "Все традиции",
    "tradition": "ТРАДИЦИЯ",
    "tags": "ТЕГИ",
    "segmentAll": "Все",
    "segmentAgape": "Agapē",
    "segmentMasters": "Мастера",
    "eventCount": "{{count}} Событие",
    "eventCount_plural": "{{count}} Событий",
    "live": "ЭФИР",
    "subscribedBtn": "ПОДПИСАН",
    "notifyMe": "НАПОМНИТЬ",
    "loadingEvents": "Загрузка событий...",
    "noEventsFound": "События не найдены",
    "noEventsForTradition": "Нет событий по традиции «{{tradition}}».",
    "noEventsForTags": "Нет событий по выбранным тегам.",
    "noMasterEvents": "Нет событий от мастеров.",
    "noAgapeEvents": "Нет событий Agapē.",
    "noEventsDefault": "Событий пока нет.",
    "clearFilters": "Сбросить фильтры",
    "tryAgain": "Повторить",
    "calendarDownloaded": "Файл календаря загружен",
    "calendarFailed": "Не удалось загрузить файл календаря",
    "reminderSet": "Напоминание установлено",
    "reminderFailed": "Не удалось установить напоминание"
  },
  "filters": {
    "master": "Мастер",
    "specialty": "Направление",
    "timeOfDay": "Время суток",
    "morning": "Утро",
    "afternoon": "День",
    "evening": "Вечер",
    "night": "Ночь",
    "allMasters": "Все мастера",
    "allSpecialties": "Все",
    "clearAll": "Сбросить фильтры",
    "noResults": "Нет сессий по выбранным фильтрам",
    "clearAndRetry": "Сбросить фильтры",
    "searchMasters": "Поиск мастеров..."
  },
  "detail": {
    "loading": "Подключение к Live-сессии...",
    "unavailable": "Live-сессия недоступна",
    "unavailableHint": "Эта Live-сессия не найдена или больше недоступна.",
    "programLiveGone": "Этой Live-сессии больше нет в расписании",
    "programLiveGoneHint": "Мастер отменил или удалил её. Она входила в программу «{{program}}» — актуальное расписание там.",
    "programLiveGoneHintNoTitle": "Мастер отменил или удалил её. Актуальное расписание — на странице программы.",
    "openProgram": "Перейти к программе",
    "backToLives": "Вернуться к событиям",
    "backToSchedule": "К КАЛЕНДАРЮ",
    "ended": "Сессия завершена",
    "endedHint": "Live-сессия с {{name}} завершилась. Запись может появиться позже.",
    "viewMaster": "ПРОФИЛЬ МАСТЕРА",
    "invite": "Пригласить",
    "edit": "Редактировать",
    "signIn": "Войти",
    "translate": "Перевод",
    "streamingTranslation": "Потоковый перевод",
    "chooseLanguage": "Выберите язык",
    "searchLanguages": "Поиск языка...",
    "noLanguagesMatch": "Языки не найдены",
    "noLanguages": "Дополнительных языков нет",
    "signUpReserve": "Создайте аккаунт, чтобы занять место",
    "cancelReservation": "Отменить бронь?",
    "cancelReservationHint": "Вы больше не будете получать напоминания об этой сессии.",
    "keep": "Оставить",
    "cancelReservationBtn": "Отменить бронь",
    "signUpReminders": "Зарегистрируйтесь для напоминаний",
    "signUpFavorites": "Зарегистрируйтесь для сохранения избранного",
    "inFavorites": "В ИЗБРАННОМ",
    "addToFavorites": "В ИЗБРАННОЕ",
    "remindMe": "Напомнить",
    "calendar": "Календарь",
    "inboxLink": "Ссылка для подключения будет отправлена на вашу почту за 10 минут до начала сессии.",
    "follow": "Подписаться",
    "following": "Вы подписаны",
    "aboutSession": "Об этой сессии",
    "presenter": "Ведущий"
  },
  "cancelDialog": {
    "title": "Отменить событие?",
    "message": "«{{title}}» будет отменено. {{notice}} Действие нельзя отменить.",
    "confirm": "Отменить событие",
    "keep": "Не отменять",
    "done": "Событие удалено",
    "noticeCircle": "Подписчики получат уведомление в чате Круга.",
    "noticeProgram": "Купившие программу получат уведомление.",
    "noticeSignedUp": "Записавшиеся получат уведомление."
  },
  "status": {
    "streamingNow": "LIVE",
    "startsInDays": "НАЧАЛО ЧЕРЕЗ {{days}}Д {{hours}}Ч",
    "startsInHours": "НАЧАЛО ЧЕРЕЗ {{hours}}Ч {{minutes}}М",
    "startsInMinutes": "НАЧАЛО ЧЕРЕЗ {{minutes}}М"
  },
  "stream": {
    "connecting": "Подключение к Live-сессии...",
    "waitingForHost": "Ожидание начала Live-сессии...",
    "unavailable": "Live-сессия недоступна",
    "endConfirm": "Вы уверены, что хотите остановить Live-сессию?",
    "endBroadcast": "Завершить Live-сессию",
    "endStream": "Остановить",
    "endLiveEvent": "Завершить событие",
    "endLiveConfirm": "Это остановит Live-сессию И завершит событие для всех зрителей. Вы уверены?",
    "endReadyConfirm": "Это завершит событие, и оно станет невидимым. Вы уверены?"
  },
  "broadcast": {
    "webOnly": "Live-сессия доступна только в браузере",
    "inProgress": "Live-сессия идёт",
    "leaveConfirm": "Ваша Live-сессия идёт. Уход со страницы завершит её. Продолжить?",
    "stay": "Остаться",
    "endAndLeave": "Завершить и уйти",
    "studio": "СТУДИЯ",
    "dashboard": "Панель управления",
    "preparing": "Подготовка студии...",
    "readyTitle": "Готовы к Live-сессии",
    "readyHint": "Камера включится в начале Live-сессии",
    "connectingStream": "Подключение к Live-сессии...",
    "complete": "Live-сессия завершена",
    "savedHint": "Сессия успешно сохранена",
    "connectionError": "Ошибка подключения",
    "sessionDetails": "ДЕТАЛИ СЕССИИ",
    "titleLabel": "Название",
    "scheduledLabel": "Запланировано",
    "durationLabel": "Длительность",
    "goLive": "НАЧАТЬ LIVE-СЕССИЮ",
    "backToDashboard": "НА ПАНЕЛЬ",
    "cancelEvent": "Отменить событие",
    "nowStreaming": "LIVE",
    "liveSessionDefault": "Live-сессия",
    "rec": "REC",
    "endStreamBtn": "ЗАВЕРШИТЬ LIVE-СЕССИЮ",
    "muted": "Звук выкл.",
    "audioOn": "Звук вкл.",
    "cameraOff": "Камера выкл.",
    "videoOn": "Камера вкл.",
    "endFailed": "Ошибка завершения: {{error}}"
  },
  "guest": {
    "webOnlyTitle": "Гостевая Live-сессия доступна только в браузере",
    "webOnlyBody": "Откройте ссылку на компьютере, чтобы подключиться с микрофоном и камерой.",
    "limitReachedTitle": "Места уже заняты",
    "limitReachedBody": "В этой Live-сессии все места для гостей заняты. Вы можете присоединиться как зритель — будете видеть и слышать всех спикеров и общаться в чате.",
    "watchAsViewer": "Смотреть как зритель",
    "openRecording": "Открыть запись",
    "expiredTitle": "Ссылка больше не действует",
    "expiredBody": "Эта ссылка отозвана или истекла. Попросите ведущего прислать новую.",
    "notStartedTitle": "Live-сессия ещё не началась",
    "notStartedBody": "Ведущий пока не открыл Live-сессию. Обновите страницу через минуту или дождитесь приглашения.",
    "connectFailedTitle": "Не удалось подключиться",
    "media": {
      "retry": "Повторить",
      "system_blockedTitle": "Камеру закрыла система",
      "system_blockedBody": "Браузер доступ получил, а операционная система его не отдаёт. На Mac: Системные настройки → Конфиденциальность и безопасность → Камера и Микрофон, включите там свой браузер и перезапустите его. На Windows: Параметры → Конфиденциальность → Камера и Микрофон. После этого вернитесь сюда и нажмите «Повторить».",
      "deniedTitle": "Нет доступа к камере и микрофону",
      "deniedBody": "Браузер не пустил нас к камере. Нажмите на значок замка слева от адреса страницы, разрешите камеру и микрофон — и вернитесь к «Повторить».",
      "not_foundTitle": "Камера или микрофон не найдены",
      "not_foundBody": "Мы не видим ни одной камеры или микрофона. Подключите устройство и нажмите «Повторить». Если камера встроенная — проверьте, не отключена ли она в настройках системы.",
      "in_useTitle": "Камеру занимает другая программа",
      "in_useBody": "Похоже, камера уже используется в другой вкладке или программе — например, в видеозвонке. Закройте её и нажмите «Повторить»."
    },
    "masterDisconnectedTitle": "Ведущий отключился",
    "masterDisconnectedBody": "Связь с ведущим прервалась. Ждём ещё несколько секунд — если он вернётся, Live-сессия продолжится.",
    "streamEndedTitle": "Live-сессия завершена",
    "streamEndedBody": "Ведущий завершил Live-сессию. Спасибо, что были рядом. Запись и информация о событии — на странице Live-сессии."
  },
  "share": {
    "subject": "Присоединяйтесь к Live-сессии «{{title}}» на Agapella",
    "message": "Присоединяйтесь к Live-сессии «{{title}}» на Agapella\n{{url}}"
  },
  "wizard": {
    "audioCategory": {
      "All": "Все",
      "Ambient": "Эмбиент",
      "BinauralBeats": "Бинауральные ритмы",
      "NatureSounds": "Звуки природы",
      "Mantra": "Мантры",
      "TibetanBowls": "Тибетские чаши",
      "WhiteNoise": "Белый шум",
      "Other": "Другое"
    },
    "libraryCount": {
      "shown": "Показано {{shown}} из {{total}}",
      "partial": "Показано {{shown}} · библиотека загружена не полностью ({{loaded}} из {{total}})"
    },
    "libraryEmpty": {
      "noResults": "По вашему запросу ничего не найдено",
      "clearSearch": "Очистить поиск"
    }
  },
  "native": {
    "rooms": {
      "calendar": {
        "openMonthA11y": "\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043c\u0435\u0441\u044f\u0446",
        "prevMonthA11y": "\u041f\u0440\u0435\u0434\u044b\u0434\u0443\u0449\u0438\u0439 \u043c\u0435\u0441\u044f\u0446",
        "nextMonthA11y": "\u0421\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u043c\u0435\u0441\u044f\u0446"
      },
      "title": "Live-\u0441\u0435\u0441\u0441\u0438\u0438",
      "intro": "\u0421\u043e\u0432\u043c\u0435\u0441\u0442\u043d\u044b\u0435 \u043e\u043d\u043b\u0430\u0439\u043d-\u0441\u0435\u0441\u0441\u0438\u0438 \u0432 \u0440\u0435\u0430\u043b\u044c\u043d\u043e\u043c \u0432\u0440\u0435\u043c\u0435\u043d\u0438 \u0438 \u0437\u0430\u043f\u0438\u0441\u0438 \u043f\u0440\u043e\u0448\u0435\u0434\u0448\u0438\u0445 \u0432\u0441\u0442\u0440\u0435\u0447 \u043e\u0442 \u043c\u0430\u0441\u0442\u0435\u0440\u043e\u0432 Agapella.",
      "create": "\u0421\u043e\u0437\u0434\u0430\u0442\u044c Live-\u0441\u0435\u0441\u0441\u0438\u044e",
      "tabs": {
        "upcoming": "\u0421\u043a\u043e\u0440\u043e",
        "archive": "\u0410\u0440\u0445\u0438\u0432"
      },
      "clearDateA11y": "\u0421\u0431\u0440\u043e\u0441\u0438\u0442\u044c \u0434\u0430\u0442\u0443: {{date}}",
      "empty": {
        "upcoming": "\u0421\u043a\u043e\u0440\u043e \u0437\u0434\u0435\u0441\u044c \u043d\u0438\u0447\u0435\u0433\u043e \u043d\u0435\u0442",
        "upcomingHint": "\u0421\u043e\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u043e\u044e \u043f\u0440\u0430\u043a\u0442\u0438\u043a\u0443 \u0438 \u043f\u0440\u0438\u0433\u043b\u0430\u0441\u0438\u0442\u0435 \u0435\u0434\u0438\u043d\u043e\u043c\u044b\u0448\u043b\u0435\u043d\u043d\u0438\u043a\u043e\u0432.",
        "upcomingDay": "\u041d\u0430 {{date}} \u043d\u0435\u0442 \u0437\u0430\u043f\u043b\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0445 Live-\u0441\u0435\u0441\u0441\u0438\u0439",
        "upcomingDayHint": "\u0425\u043e\u0442\u0438\u0442\u0435 \u0437\u0430\u043f\u043b\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0441\u0432\u043e\u044e Live-\u0441\u0435\u0441\u0441\u0438\u044e \u043d\u0430 \u044d\u0442\u043e\u0442 \u0434\u0435\u043d\u044c?",
        "archive": "\u0417\u0430\u043f\u0438\u0441\u0435\u0439 \u043f\u043e\u043a\u0430 \u043d\u0435\u0442",
        "archiveHint": "\u0417\u0430\u043f\u0438\u0441\u0438 \u043c\u0430\u0441\u0442\u0435\u0440-\u0441\u0435\u0441\u0441\u0438\u0439 \u043f\u043e\u044f\u0432\u044f\u0442\u0441\u044f \u0437\u0434\u0435\u0441\u044c \u043f\u043e\u0441\u043b\u0435 \u043f\u0435\u0440\u0432\u044b\u0445 \u043f\u0440\u0430\u043a\u0442\u0438\u043a.",
        "archiveDay": "\u041d\u0430 {{date}} \u043d\u0435\u0442 \u0437\u0430\u043f\u0438\u0441\u0435\u0439 \u043f\u0440\u0430\u043a\u0442\u0438\u043a",
        "archiveDayHint": "\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0440\u0443\u0433\u043e\u0439 \u0434\u0435\u043d\u044c \u0432 \u043a\u0430\u043b\u0435\u043d\u0434\u0430\u0440\u0435 \u0438\u043b\u0438 \u0432\u0435\u0440\u043d\u0438\u0442\u0435\u0441\u044c \u043a\u043e \u0432\u0441\u0435\u043c \u0437\u0430\u043f\u0438\u0441\u044f\u043c."
      },
      "card": {
        "seats_one": "{{taken}} \u0438\u0437 {{count}} \u043c\u0435\u0441\u0442\u0430",
        "seats_few": "{{taken}} \u0438\u0437 {{count}} \u043c\u0435\u0441\u0442",
        "seats_many": "{{taken}} \u0438\u0437 {{count}} \u043c\u0435\u0441\u0442",
        "seats_other": "{{taken}} \u0438\u0437 {{count}} \u043c\u0435\u0441\u0442",
        "recording": "\u0417\u0430\u043f\u0438\u0441\u044c \u00b7 {{duration}}",
        "live": "\u0421\u0435\u0439\u0447\u0430\u0441",
        "own": "\u0412\u0430\u0448\u0430",
        "untitled": "\u0411\u0435\u0437 \u043d\u0430\u0437\u0432\u0430\u043d\u0438\u044f",
        "shareA11y": "\u041f\u043e\u0434\u0435\u043b\u0438\u0442\u044c\u0441\u044f: {{title}}"
      }
    },
    "subtitle": "Ваш путь практики и встреч",
    "calendarOverline": "СТИЛЬ ЖИЗНИ",
    "eventsOn": "Событие на {{date}}",
    "eventsOnDay": "События на",
    "allEvents": "Все события",
    "noEventsThisDay": "На этот день событий нет",
    "noUpcoming": "Предстоящих событий нет",
    "whatsNext": "Что будет дальше",
    "nothingPlanned": "Пока ничего не запланировано",
    "legend": {
      "online": "Онлайн",
      "offline": "Офлайн",
      "recordings": "Записи",
      "all": "Все"
    },
    "filters": {
      "directions": "Направления",
      "directionsCount": "Направления ({{count}})",
      "liveSessions": "Live-сессии",
      "offline": "Офлайн",
      "livePractices": "Live-практики",
      "allDirections": "Все направления"
    },
    "pickMonth": "Выберите месяц",
    "pickMonthA11y": "Выбрать месяц",
    "done": "Готово",
    "collections": {
      "title": "Подборки",
      "seeAll": "Смотреть все ›"
    },
    "card": {
      "event": "Событие",
      "minutes": "мин",
      "master": "Мастер",
      "yours": "Ваша Live-сессия",
      "going": "Я иду",
      "join": "Присоединиться",
      "offline": "ОФЛАЙН",
      "online": "ОНЛАЙН",
      "open": "Перейти"
    },
    "signInToJoin": "Войдите, чтобы записаться на событие",
    "gridWeekdays": [
      "П",
      "В",
      "Ср",
      "Ч",
      "П",
      "С",
      "Вс"
    ],
    "filtersTitle": "Фильтры",
    "reset": "Сбросить",
    "format": "Формат",
    "durationTitle": "Длительность",
    "showEvents": "Показать события",
    "duration": {
      "any": "Любая",
      "lt30": "До 30 мин",
      "30to60": "30–60 мин",
      "gt60": "60+ мин"
    },
    "detail": {
      "notFound": "Событие не найдено",
      "participants": "Кто участвует",
      "about": "О событии",
      "youWillGet": "Вы получите",
      "free": "Бесплатно",
      "liveNow": "Идёт сейчас",
      "ended": "Live-сессия завершена",
      "recordingOptional": "Запись по желанию",
      "watchRecording": "Смотреть запись",
      "noRecording": "Записи нет",
      "openLive": "Открыть Live-сессию",
      "openChat": "Чат Live-сессии",
      "previewLive": "Предпросмотр Live-сессии",
      "registered": "Вы записаны",
      "register": "Записаться"
    },
    "rsvp": {
      "going": "Пойдут",
      "maybe": "Возможно",
      "no": "Не пойдут",
      "total": "Участников",
      "soonTitle": "Список участников скоро",
      "soonText": "Отметки «Пойду / Возможно / Не пойду» появятся, когда подключим этот раздел на бэкенде."
    },
    "summary": {
      "followFailed": "Не удалось подписаться",
      "tabRecording": "Запись",
      "tabChat": "Чат",
      "metaPeople_one": "{{count}} чел.",
      "metaPeople_few": "{{count}} чел.",
      "metaPeople_many": "{{count}} чел.",
      "metaPeople_other": "{{count}} чел.",
      "metaMessages_one": "{{count}} сообщ.",
      "metaMessages_few": "{{count}} сообщ.",
      "metaMessages_many": "{{count}} сообщ.",
      "metaMessages_other": "{{count}} сообщ.",
      "shareA11y": "Поделиться Live-сессией",
      "endedBadge": "LIVE-СЕССИЯ ЗАВЕРШЕНА",
      "untitled": "Без названия",
      "host": "Ведущий: {{name}}",
      "lasted": "Длилось {{duration}}",
      "peopleWere_one": "Было {{count}} человек",
      "peopleWere_few": "Было {{count}} человека",
      "peopleWere_many": "Было {{count}} человек",
      "peopleWere_other": "Было {{count}} человек",
      "messageCount": "Сообщений в чате: {{count}}",
      "noChat": "В этой сессии не переписывались.",
      "openAuthor": "Открыть профиль {{name}}",
      "subscribing": "Подписываем…",
      "viewCount": "Просмотров записи: {{count}}",
      "publish": "Опубликовать в Медиа",
      "deleteAction": "Удалить Live-сессию",
      "deleting": "Удаляем…",
      "deleteTitle": "Удалить Live-сессию?",
      "deleteBody": "Live-сессия «{{title}}» будет удалена целиком: вместе с ней уйдут запись, чат, статистика и место в вашей истории. Из «Медиа» запись тоже исчезнет.",
      "deleteConfirm": "Удалить Live-сессию",
      "deleteFailed": "Не удалось удалить сессию"
    },
    "sessionConflict": {
      "title": "Сейчас идёт Live-сессия",
      "body": {
        "room": "Чтобы перейти в другую Live-сессию, сначала выйдите из «{{title}}».",
        "watch": "Чтобы смотреть эту Live-сессию, сначала выйдите из «{{title}}».",
        "broadcast": "Чтобы начать свою Live-сессию, сначала выйдите из «{{title}}»."
      },
      "untitled": "Live-сессия",
      "stay": "Остаться",
      "leave": "Выйти",
      "watchBlocked": "Видео откроется, когда вы выйдете из текущей Live-сессии.",
      "watchBlockedAction": "Выйти из Live-сессии"
    },
    "guest": {
      "publishDenied": "Слово выдано, но микрофон пока не открылся. Выйдите и зайдите снова или попросите ведущего выдать слово ещё раз"
    },
    "roomHeader": {
      "participants_one": "{{count}} участник",
      "participants_few": "{{count}} участника",
      "participants_many": "{{count}} участников",
      "participants_other": "{{count}} участников",
      "guestsA11y": "Смотрят без аккаунта: {{count}}. Открыть список",
      "host": "Хост",
      "collapse": "Свернуть Live-сессию",
      "menu": "Меню Live-сессии",
      "recording": "Идёт запись Live-сессии. Подробнее",
      "recordingHintTitle": "Идёт запись Live-сессии",
      "recordingHintBody": "Всё, что видно и слышно, записывается.",
      "recordingHintOk": "Понятно"
    },
    "chatToast": {
      "a11y": "Новое сообщение в чате от {{author}}: {{text}}. Открыть чат"
    },
    "media": {
      "muteA11y": "Выключить звук практики на этом устройстве",
      "unmuteA11y": "Включить звук практики"
    }
  }
}
